import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Link } from 'react-router-dom';

@inject('routesStore', 'translationsStore') @observer
class TabItem extends Component {

    shouldComponentUpdate(nextProps) {

        if(nextProps.routesStore.selectedTabId != this.props.selectedTabId) {

            return true;
        }

        return false;
    }

    handleTabClick = (e) => {

        this.props.routesStore.setSelectedTabId(this.props.id);
    }

    render() {

        const selectedTabId = this.props.routesStore.selectedTabId;

        const itemClass = this.props.cssClass ? this.props.cssClass : 'tabs-list-item';
        const className = selectedTabId == this.props.id ? 'selected' : '';
        
        return(
            <li key={this.props.index}
                onClick={this.handleTabClick}
                data-cy={`${this.props.text}_TAB`}
                className={className}>
                <Link to={this.props.url} className={itemClass}>
                    { this.props.translationsStore.translate(this.props.text) }
                </Link>
            </li>
        );
    }
}

export default TabItem;